// Util compartilhado — monta o HTML completo do documento pra pré-visualização
// de templates (usado no modal ModalPreviewV2 e no comando "preview-tab" do
// editor V2). Mantém tudo em um lugar só pra os dois cenários ficarem iguais.

// CSS das classes do FormMounted (extraído de src/assets/scss/gs.scss).
export const FORM_CSS = `
  /* Neutraliza o .label do Spectre.css (que pinta fundo cinza como se
     fosse badge) quando é usado no LabelDisplay do FormMounted. */
  .custom-input-container .label,
  .displayed-label > .label {
    background: transparent !important;
    padding: 0 !important;
    border-radius: 0 !important;
    font-size: inherit !important;
    color: inherit !important;
    line-height: inherit !important;
  }
  .custom-input-container { margin: 15px 0; }
  .displayed-config-container { display: flex; justify-content: space-between; }
  .displayed-config-container .displayed-label { display: flex; align-self: end; align-items: baseline; }
  .input-mg-rgt { margin-right: 10px; }
  .main-question-options { margin-bottom: 10px; font-size: 14px; font-weight: 700; }
  .form-label { display: inline-block; margin-bottom: 6px; margin-right: 2px; font-size: 14px; }
  .form-control { font-size: 14px; padding: 8px 12px; }
  button.displayed-label, .btn.displayed-label {
    align-self: auto !important;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    padding: 10px 24px;
    font-size: 15px;
    line-height: 1.4;
    min-height: 42px;
    margin: 12px 0 24px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    color: #fff;
  }
  .ssr-select { position: relative; }
  .ssr-select > summary,
  .ssr-select-summary {
    list-style: none;
    width: 100%;
    min-height: 38px;
    padding: 6px 8px 6px 12px;
    border: 1px solid #cccccc;
    border-radius: 4px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #808080;
    box-sizing: border-box;
    user-select: none;
  }
  .ssr-select > summary::-webkit-details-marker { display: none; }
  .ssr-select-arrow {
    display: flex;
    align-items: center;
    padding-left: 8px;
    border-left: 1px solid #cccccc;
    color: #cccccc;
    height: 20px;
  }
  .ssr-select-chevron { transition: transform 0.15s; }
  .ssr-select[open] .ssr-select-chevron { transform: rotate(180deg); }
  .ssr-select-menu {
    position: absolute;
    width: 100%;
    margin-top: 4px;
    background: #fff;
    border: 1px solid #cccccc;
    border-radius: 4px;
    box-shadow: 0 4px 11px rgba(0,0,0,0.1);
    max-height: 200px;
    overflow-y: auto;
    z-index: 10;
  }
  .ssr-select-option {
    padding: 8px 12px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;
  }
  .ssr-select-option:last-child { border-bottom: none; }
  .ssr-select-option:hover { background: #f7f8fa; }
  @media (max-width: 900px) {
    .row-wrapper-form { display: flex; flex-direction: column; }
  }
`;

// Script pra o mock do Select (SSR) abrir/fechar corretamente.
export const SSR_SELECT_SCRIPT = `
  document.addEventListener('click', function (e) {
    var summary = e.target.closest ? e.target.closest('.ssr-select > summary') : null;
    if (summary) {
      setTimeout(function () {
        document.querySelectorAll('.ssr-select[open]').forEach(function (d) {
          if (!d.contains(summary)) d.removeAttribute('open');
        });
      }, 0);
      return;
    }
    if (!e.target.closest || !e.target.closest('.ssr-select')) {
      document.querySelectorAll('.ssr-select[open]').forEach(function (d) {
        d.removeAttribute('open');
      });
    }
  });
`;

export const buildPreviewDoc = (html, css) => `
  <!doctype html>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width,initial-scale=1" />
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css" />
      <link rel="stylesheet" href="https://unpkg.com/spectre.css/dist/spectre.min.css" />
      <style>
        html, body { margin: 0; padding: 0; background: #fff; width: 100%; font-size: 14px; }
        .container, .container-sm, .container-md, .container-lg,
        .container-xl, .container-xxl { max-width: 100% !important; width: 100% !important; }
        ${FORM_CSS}
        ${css || ""}
      </style>
    </head>
    <body>
      ${html || ""}
      <script>${SSR_SELECT_SCRIPT}<\/script>
    </body>
  </html>
`;
